import React, { useContext, useState, useEffect } from 'react';
import { useGetInfo } from 'hooks/infoService';
import { FeatureContext } from 'components/AccessResolvers/featureContext';
import { NotPermittedAction } from './NotPermittedAction';
import { NotPermittedRoute } from './NotPermittedRoute';

const renderChildren = ({ children }) => children;

const permissionsChecker = (SuccessComponent, FailureComponent) => {
  const IsPermitted = ({
    message,
    children,
    className,
    displayBlock,
    permissions,
  }) => {
    const [isPermitted, setIsPermitted] = useState(false);

    const { data: user } = useGetInfo();
    const {
      featureState: { authV3Enabled },
    } = useContext(FeatureContext);

    const checkPermissions = () => {
      if (!user) return false;

      const isSuperAdmin = authV3Enabled
        ? user?.superAdmin
        : user?.is_super_admin;

      const requiredPermissions = user?.permissions || permissions;

      // if SUPER_ADMIN grant access
      if (isSuperAdmin) return true;

      // Otherwise check if user has appropriate permissions
      return (
        requiredPermissions &&
        requiredPermissions.length > 0 &&
        requiredPermissions.some((requiredPermission) =>
          user?.permissions.includes(requiredPermission),
        )
      );
    };

    useEffect(() => {
      const permitted = checkPermissions();

      setIsPermitted(permitted);
    }, [user]);

    return (
      <>
        {isPermitted && user && (
          <SuccessComponent
            {...{
              isPermitted,
              className,
              children:
                typeof children === 'function'
                  ? children(isPermitted)
                  : children,
              message,
              displayBlock,
            }}
          />
        )}
        {!isPermitted && user && (
          <FailureComponent
            {...{
              isPermitted,
              className,
              children:
                typeof children === 'function'
                  ? children(isPermitted)
                  : children,
              message,
              displayBlock,
            }}
          />
        )}
      </>
    );
  };

  return IsPermitted;
};

export const IsActionPermitted = permissionsChecker(
  renderChildren,
  NotPermittedAction,
);
export const IsRoutePermitted = permissionsChecker(
  renderChildren,
  NotPermittedRoute,
);

export const routeWithPermissions = (component) =>
  permissionsChecker(component, NotPermittedRoute);
